import { useMemo } from 'react'

import {
  useMutationDisableBookingInsurance,
  useMutationEnableBookingInsurance,
  useQueryGetBookingById,
} from '@flecto/core/saas'
import { type ParameterID } from '@flecto/types'

type UseBookingInsuranceInfoOptions = {
  bookingId?: ParameterID
}

export function useBookingInsuranceToggleStatus({
  bookingId,
}: UseBookingInsuranceInfoOptions) {
  const { data: booking } = useQueryGetBookingById({ bookingId })

  const {
    mutateAsync: enableBookingInsurance,
    isLoading: isEnablingBookingInsurance,
  } = useMutationEnableBookingInsurance()

  const {
    mutateAsync: disableBookingInsurance,
    isLoading: isDisablingBookingInsurance,
  } = useMutationDisableBookingInsurance()

  const isBookingInsuranceEnabled = useMemo(() => booking?.insured, [booking])

  const isToggling = isEnablingBookingInsurance || isDisablingBookingInsurance

  const toggleBookingInsuranceStatus = () => {
    if (isBookingInsuranceEnabled) {
      disableBookingInsurance({ bookingId })
    } else {
      enableBookingInsurance({ bookingId })
    }
  }

  return {
    isToggling,
    isBookingInsuranceEnabled,
    toggleBookingInsuranceStatus,
  }
}
